import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { RefundRequest } from '../refund-request';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Currency } from '../currency';
import { UserService } from '../service/user.service';
import { ToastMessageService } from '../toast-message.service';
import Decimal from 'decimal.js';
import { DecimalValidator } from '../validator/decimal-validator';
import { UserForBackend } from '../user-for-backend';
import { environment } from 'src/environments/environment';
import { ApiError } from '../api-error';
import { forkJoin } from 'rxjs';
import { BookingIdListItem } from '../booking-id-list-item';

@Component({
  selector: 'app-refund-request-edit',
  templateUrl: './refund-request-edit.component.html',
  styleUrls: ['./refund-request-edit.component.css']
})
export class RefundRequestEditComponent implements OnInit {

  selectedRequest!: RefundRequest;
  users!: UserForBackend[];
  requestForm!: FormGroup;
  currencies: Currency[] = [];
  linkToBooking!: string;
  studentName: string = "";
  isBookingIdsReady: boolean = false;
  bookingIds: BookingIdListItem[] = [];

  authorities = [
    { id: 7, name: "Alain" },
    { id: 6, name: "Véronique" }
  ];

  constructor(
    private httpService: HttpService,
    private favicon: FaviconService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private builder: FormBuilder,
    public userService: UserService,
    private toastService: ToastMessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit() {
    let requestId = parseInt(this.route.snapshot.paramMap.get("requestId")!);
    forkJoin({
      users: this.httpService.getActiveUsers(),
      currencies: this.httpService.getCurrencies(),
      request: this.httpService.getRefundRequestById(requestId),
      bookingIds: this.httpService.getRecentBookingIds()
    }).subscribe(({
      users, currencies, request, bookingIds
    }) => {
      this.bookingIds = bookingIds;
      this.selectedRequest = request;
      this.setLinkToBooking();
      this.users = users;
      this.currencies = currencies;
      this.studentName = request.studentName;
      this.requestForm = this.builder.group({
        bookingIdArray: this.builder.array([]),
        amount: [new Decimal(this.selectedRequest.amount), [Validators.required, DecimalValidator]],
        currency: this.selectedRequest.currency,
        requestedBy: this.selectedRequest.requestedBy,
        reason: this.selectedRequest.reason,
        iban: this.selectedRequest.iban,
        approvedBy: this.selectedRequest.approvedBy,
        isPaid: this.selectedRequest.isPaid,
        bic: this.selectedRequest.bic,
        isApproved: this.selectedRequest.isApproved,
        accountHolderName: this.selectedRequest.accountHolderName,
      });
      for(let bookingIdListItem of this.selectedRequest.bookingIds){
        this.bookingIdArray.controls.push(new FormControl(bookingIdListItem));
      }
      this.checkAmountFormat();
      // this.checkBookingIdFormat();
      this.isBookingIdsReady = true;
    });
  }

  deleteBookingIdControl(index: number) {
    this.bookingIdArray.removeAt(index);
    // this.onBookingIdChange();
  }

  setLinkToBooking(){
    if(this.selectedRequest.bookingIds.length == 0){
      return;
    }
  }

  onBookingIdChange() {
    let bookingIds: number[] = [];
    for (let control of this.bookingIdArray.controls) {
      if (control.value) {
        bookingIds.push(control.value.bookingId);
      }
    }
    if (bookingIds.length == 0) {
      this.studentName = "";
    } else {
      this.httpService.getStudentNameByBookingIdList(bookingIds).subscribe(res => {
        this.studentName = res;
      }, error => this.toastService.addApiError(new ApiError(error)));
    }
  }

  get bookingIdArray(): FormArray {
    return this.requestForm.get("bookingIdArray") as FormArray;
  }

  addBookingIdControl() {
    this.bookingIdArray.push(new FormControl());
  }

  openBooking(selectedValue: BookingIdListItem){
    let link =  environment.lvConnectBaseUrl + "/management/edit-booking/" + selectedValue.bookingId;
    window.open(link, '_blank');
  }

  compareId(item1: any, item2: any) {
    return item1 && item2 ? item1.id == item2.id : item1 == item2;
  }

  sendForm() {
    if(this.bookingIdArray.controls.length == 0){
      this.toastService.addError("Error", "Please specify at least one booking id");
      return;
    }
    this.selectedRequest.approvedBy = this.requestForm.value.approvedBy;
    this.selectedRequest.amount = new Decimal(this.requestForm.value.amount);
    this.selectedRequest.currency = this.requestForm.value.currency;
    this.selectedRequest.requestedBy = this.requestForm.value.requestedBy;
    this.selectedRequest.reason = this.requestForm.value.reason;
    this.selectedRequest.iban = this.requestForm.value.iban;
    this.selectedRequest.bic = this.requestForm.value.bic;
    this.selectedRequest.isPaid = this.requestForm.value.isPaid;
    this.selectedRequest.accountHolderName = this.requestForm.value.accountHolderName;

    this.selectedRequest.bookingIds = [];
    for(let control of this.bookingIdArray.controls){
      if(control.value){
        this.selectedRequest.bookingIds.push(control.value);
      }
    }
    this.httpService.updateRefundRequest(this.selectedRequest).subscribe(() => {
      this.toastService.addSuccess("Success", "Updated successfully");
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

  checkAmountFormat() {
    this.requestForm.get("amount")!.valueChanges.subscribe(val => {
      let index = val.indexOf(",");
      if (index != -1) {
        let newValue = val.substring(0, index) + "." + val.substring(index + 1, val.length);
        this.requestForm.get("amount")!.setValue(newValue.replace(/[^0-9\.]/g, ""));
      } else {
        let newValue = val.replace(/[^0-9\.]/g, "");
        if (newValue != val) {
          this.requestForm.get("amount")!.setValue(newValue);
        }
      }
    });
  }

  checkBookingIdFormat(){
    this.requestForm.get("bookingId")!.valueChanges.subscribe(val => {
      if(val.toLowerCase().indexOf("lv") != -1){
        let newVal = val.replace(/lv/gi, "");
        this.requestForm.get("bookingId")!.setValue(newVal);
      }
      if(val.includes("&")){
        let newVal = val.replace(/&/gi, "");
        this.requestForm.get("bookingId")!.setValue(newVal);
      }
      if(val.includes(",")){
        let newVal = val.replace(/,/gi, "");
        this.requestForm.get("bookingId")!.setValue(newVal);
      }
      if(val.includes(" ")){
        let newVal = val.replace(/ /gi, "");
        this.requestForm.get("bookingId")!.setValue(newVal);
      }
    });
  }

  approveRequest() {
    this.httpService.approveRefundRequest(this.selectedRequest).subscribe(res => {
      this.requestForm.get("isApproved")!.setValue(true);
      this.selectedRequest.isApproved = true;
      this.toastService.addSuccess("Success", "This request is approved.");
    }, error => this.toastService.addError("Error", error.message));
  }

  encodeRefundPayment(){
    this.httpService.encodeRefundPayment(this.selectedRequest).subscribe({
      next: () => {
        this.requestForm.get("isPaid")!.setValue(true);
        this.selectedRequest.isPaid = true;
        this.toastService.addSuccess("Success", "This request is paid.");
      },
      error: (error) => {
        let apiError = new ApiError(error);
        this.toastService.addError("Error", apiError.message);
      }
    });
  }
}
